// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown[data-v-4b8aba90]{display:none!important}@media(min-width:1280px){.dropdown[data-v-4b8aba90]{display:inline-flex!important}}.dropdown .dropdown-menu[data-v-4b8aba90]{display:none;right:0;left:inherit}.dropdown:hover .dropdown-menu[data-v-4b8aba90]{display:block!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
